import type { ServiceType } from '@mathflat/domain/Student'

import commonRepo from '@/repository/common.repo'

import type { SubjectAvailability } from './subjectMenu'

/**
 * 과목 노출 판정 축이 고객 유형에 따라 다르다. 둘을 섞으면 한쪽 정책이 다른 쪽으로 샌다.
 *
 * - B2B — 계정 권한(`/users/me` 의 restrictions)만 본다. 과목을 계정별로 부여하므로 기존 판정 그대로다.
 * - B2G — 계정별 부여가 어려워 restrictions 를 전부 풀어둔다. 권한 축만 보면 전 과목이 열리므로,
 *   학원이 계약한 과목(`/academies` 의 serviceSubscriptions)으로 한 번 더 좁힌다.
 *
 * 선생님 단위 과목(`/teachers/{id}` 의 allowedServiceTypes)은 여기서 보지 않는다 — 메뉴에서 과목을
 * 누른 뒤 이용 동의를 받을지 판단하는 축이라 단계가 다르다(전환 훅 담당).
 *
 * 학원 정보가 아직 없으면 B2G 인지 알 수 없다. 이때 권한 축만 보는 것은 B2B 의 기존 동작을 그대로
 * 두기 위한 것이다 — 여기서 숨기면 B2B 의 노출 시점이 바뀐다.
 */
function isSubjectVisible(isFeatureAllowed: boolean, subject: ServiceType): boolean {
  if (!isFeatureAllowed) return false

  const academy = commonRepo.academy
  if (!academy?.isB2G) return true

  return academy.serviceSubscriptions.includes(subject)
}

// commonRepo getter 를 호출 시점에 읽으므로, 반응성을 얻으려면 observer 안에서 호출해야 한다.
export function getSubjectAvailability(): SubjectAvailability {
  const featurePermission = commonRepo.permission.byFeature

  return {
    isScienceflatFeatureAllowed: isSubjectVisible(
      featurePermission.isAllowed('CONTENT_SCIENCEFLAT'),
      'SCIENCEFLAT',
    ),
    isEnglishflatFeatureAllowed: isSubjectVisible(
      featurePermission.isAllowed('CONTENT_ENGLISHFLAT'),
      'ENGLISHFLAT',
    ),
    brand: commonRepo.appName,
  }
}
